import React, { useState } from "react";
import MenuBarIcon from "../icons/MenuBarIcon";
import Menu from "./Menu";
import { Link } from "react-router-dom";

function Navbar() {
  const [toggleMenu, setToggleMenu] = useState(false);
  const handleToggleMenu = () => {
    setToggleMenu((prev) => !prev);
  };
  return (
    <div className="navbar-container">
      <div className="tradeview-marque">
        <iframe
          src="https://widget.coinlib.io/widget?type=horizontal_v2&theme=dark&pref_coin_id=1505&invert_hover=0"
          width="100%"
          height="36px"
          scrolling="auto"
          marginWidth="0"
          marginHeight="0"
          frameBorder="0"
          style={{ border: 0, margin: 0, padding: 0 }}
        ></iframe>
      </div>
      <div className="flex-container-2">
        <div className="flex-item">
          <Link to="/" className="logo-container">
            <img src={`/assets/tetfi.png`} alt="Tefti.com" />
          </Link>
        </div>
        <div className="flex-item">
          <span className="togglebar" onClick={handleToggleMenu}>
            {/* <span>Menu</span> */}
            <span>
              <MenuBarIcon />
            </span>
          </span>
        </div>
      </div>
      <nav
        className={toggleMenu ? "nav-menu active" : " nav-menu"}
        onClick={handleToggleMenu}
      >
        <Menu />
      </nav>
    </div>
  );
}

export default Navbar;
